import styled from "styled-components";
import { Wrapper } from "../user-list/style";
import { primaryColor } from "../../../config";

export const PageWrap = styled(Wrapper)`
  .system-logs-tabs.ant-tabs-top > .ant-tabs-nav {
    margin: 0 0 1.25rem;
  }
  .system-logs-tabs .ant-tabs-nav::before {
    border-color: #eff2f5;
  }
  .system-logs-tabs .ant-tabs-tab {
    padding: 0.65rem 1.15rem;
    font-weight: 600;
    font-size: 0.95rem;
    color: #5e6278;
  }
  .system-logs-tabs .ant-tabs-tab:hover .ant-tabs-tab-btn {
    color: #181c32;
  }
  .system-logs-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${primaryColor};
    text-shadow: none;
  }
  .system-logs-tabs .ant-tabs-ink-bar {
    background: ${primaryColor};
    height: 2px;
  }
  .system-logs-tabs .ant-tabs-content-holder {
    padding-top: 0.25rem;
  }

  .system-logs-filter .ant-select .ant-select-selector {
    min-height: 40px;
    border-radius: 0.475rem;
    font-size: 0.875rem;
    border-color: #e4e6ef;
  }
  .system-logs-filter .ant-select:hover .ant-select-selector {
    border-color: #b5b5c3;
  }
  .system-logs-filter .ant-select-focused .ant-select-selector,
  .system-logs-filter .ant-select-open .ant-select-selector {
    border-color: ${primaryColor} !important;
    box-shadow: 0 0 0 2px rgba(244, 91, 104, 0.12) !important;
  }
  .system-logs-filter .ant-select-single.ant-select-show-arrow .ant-select-selection-item,
  .system-logs-filter .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
    line-height: 38px;
  }

  .system-logs-modal-pre {
    white-space: pre-wrap;
    word-break: break-word;
    font-size: 0.8125rem;
    background: #f9f9f9;
    border: 1px solid #eff2f5;
    border-radius: 0.475rem;
    padding: 1rem 1.1rem;
    margin-bottom: 0.75rem;
  }
`;
